import React from "react";

// Badge "Repetido" que al pasarle el cursor se ofrece como botón para ver el
// historial de repeticiones de la solicitud
export const BadgeRepetido = ({ item, historial }) => {
    // los dos textos van montados uno sobre otro para que el ancho no salte al
    // cambiar de uno a otro
    return (
        <button
            type="button"
            className="new-badge new-badge-warning badge-repetido"
            onClick={() => historial.AbrirHistorial(item)}
        >
            <span className="badge-repetido__estado">Repetido</span>
            <span className="badge-repetido__accion">Ver historial</span>
        </button>
    );
};
